import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Radio, Scale } from "lucide-react";
import { api, timeAgo } from "@/lib/api";
import { FactStatus } from "@/components/common";
import { FactActions } from "@/components/FactActions";

export const useLiveUpdates = (enabled, tick = 0) => {
  const [data, setData] = useState({ following: null, items: [] });
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!enabled) { api.get("/feed/live-updates").then((r) => setData({ following: r.data.following, items: [] })).catch(() => {}); return; }
    api.get("/feed/live-updates").then((r) => setData(r.data)).catch(() => {});
  }, [enabled, v, tick]);
  return { ...data, reload: () => setV((x) => x + 1) };
};

export const LiveLinks = ({ liveId, testid, dark }) => (
  <span className="inline-flex flex-wrap items-center gap-x-4 gap-y-1">
    <Link to={`/live/${liveId}`} className={`inline-flex items-center gap-1 font-medium hover:underline ${dark ? "text-white" : "text-[hsl(var(--facts))]"}`} data-testid={`${testid}-open`}>Open live record<ArrowUpRight size={13} /></Link>
    <Link to={`/live/${liveId}?tab=perspective`} className={`inline-flex items-center gap-1 font-medium hover:underline ${dark ? "text-emerald-100" : "text-[hsl(var(--facts))]"}`} data-testid={`${testid}-perspective`}><Scale size={13} />Jump to the Middle perspective</Link>
  </span>
);

export const LiveUpdateCard = ({ u }) => (
  <div className="surface border-l-4 border-l-[hsl(var(--facts))] p-4 transition-colors hover:border-emerald-300 fade-up" data-testid={`live-update-card-${u.id}`}>
    <Link to={`/facts/${u.id}`} className="block" data-testid={`live-update-fact-${u.id}`}>
      <p className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-[hsl(var(--facts))]"><Radio size={12} />Middle Live · {u.live_title}</p>
      <p className="mt-2 font-serif text-xl leading-snug hover:underline">{u.headline}</p>
      {u.summary && <p className="mt-1 line-clamp-2 text-sm text-slate-600">{u.summary}</p>}
    </Link>
    <div className="mt-3 flex flex-wrap items-center gap-2 text-xs text-slate-500">
      <FactStatus status={u.status} />
      <span>{u.source_name} · {timeAgo(u.published_at)}</span>
      <span className="ml-auto"><LiveLinks liveId={u.live_id} testid={`live-update-${u.id}`} /></span>
    </div>
    <FactActions f={u} inline className="mt-3 border-t border-border pt-2" />
  </div>
);
